// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://api.cinemaain.com`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://api.cinemaain.com`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const STAR_OMAN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImMyMjU0NzY2LTJkMzEtNDE1Yy1iMjE5LTEwOGRiOWZlODdkZCIsImlhdCI6MTc5MDkyMjE2Nn0.pSee-bq7LAmcnvW-NyvNebZdWy3PQlP3gvKgLvFMhvI`
export const TOKEN = STAR_OMAN



// WEBPACK FOOTER //
// ./src/config/index.js